import type { OverlayScrollbarsComponentRef } from 'overlayscrollbars-react';
import type { RefObject } from 'react';

export const getContainerElementFromOverlayScrollbarsRef = (
  ref: RefObject<OverlayScrollbarsComponentRef>
): HTMLElement | null => ref.current?.osInstance()?.elements().viewport ?? null;
